export const CLASS_NIVEAU_DISPONIBILITE = [
  '',
  'is-nondisponible',
  'is-partiellement',
  'is-disponible',
];

export const LISTE_DISPONIBILITE = [
  { code: 0, libelle: 'catalogue.popUpDispoFace.indisponibleStatus' },
  { code: 1, libelle: 'catalogue.popUpDispoFace.disponibleStatus' },
];
